/**
 * Generated runtime TestId mirror for frontend/src/pages/Identities.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const IdentitiesTestIds = {
  btnNewUser: "btn-new-user",
  colCreatedAt: "col-created-at",
  colDisplayName: "col-display-name",
  colEntryDate: "col-entry-date",
  colExitDate: "col-exit-date",
  colLifecycleState: "col-lifecycle-state",
  colParty: "col-party",
  colType: "col-type",
  identitiesList: "identities-list",
  identityRow: "identity-row"
} as const;
